/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { BookOpen, FileText } from 'lucide-react';
import Page from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import SnackBar from '../../../components/snackbar/snackbar';
import MCQSingleSelect from '../components/MCQSingleSelect';
import MCQMultipleSelect from '../components/MCQMultipleSelect';
import NumericAnswer from '../components/NumericAnswer';
import PassageSingleQuestion from '../components/PassageSingleQuestion';
import PassageMultipleQuestions from '../components/PassageMultipleQuestions';
import PreviewMode from '../components/QuestionPreview';
import { getValidationSchema } from '../components/questionValidationSchemas';
import adminServices from '../../../services/adminServices';

const QuestionCreate = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const questionDataFromState = location.state?.questionData;

  const fromChapterPage = location.state?.fromChapterPage;
  const fromChapterId = location.state?.fromChapterId;
  const prefillData = location.state?.prefill;
  const resolvedPrefill = prefillData;
  const [assessmentTypes, setAssessmentTypes] = useState([]);
  const [questionTypes, setQuestionTypes] = useState([]);
  const [questionTypeCodeMap, setQuestionTypeCodeMap] = useState({});

  const [sourceSearch, setSourceSearch] = useState('');
  const [chapterSearch, setChapterSearch] = useState('');
  const [sources, setSources] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [loadingDropdowns, setLoadingDropdowns] = useState(false);
  const [selectedSuperAdminChapter, setSelectedSuperAdminChapter] = useState('');

  // Ref for error field focusing
  const formRef = useRef(null);

  const difficultyTags = [
    { value: 'easy', label: 'Easy' },
    { value: 'medium', label: 'Medium' },
    { value: 'hard', label: 'Hard' },
    // { value: 'foundation', label: 'Foundation' },
  ];

  const getInitialFormData = (questionType) => {
    const baseData = {
      assessmentType: [],
      questionType: questionType || '',
      difficultyTag: '',
      source: [],
      chapter: [],
      marks: '1',
      negativeMarks: '0',
      questionText: '',
      textExplanation: '',
      youtubeVideoUrl: '',
      options: [
        { label: 'A', value: '', valuePlain: '' },
        { label: 'B', value: '', valuePlain: '' },
        { label: 'C', value: '', valuePlain: '' },
        { label: 'D', value: '', valuePlain: '' },
      ],
    };

    switch (questionType) {
      case 'MCQ':
      case 'JEEMCQ1':
        return {
          ...baseData,
          options: [
            { label: 'A', value: '', valuePlain: '' },
            { label: 'B', value: '', valuePlain: '' },
            { label: 'C', value: '', valuePlain: '' },
            { label: 'D', value: '', valuePlain: '' },
          ],
          correctAnswer: '',
        };

      case 'MCQ_MULTI':
      case 'JEEMCQ2':
        return {
          ...baseData,
          options: [
            { label: 'A', value: '', valuePlain: '' },
            { label: 'B', value: '', valuePlain: '' },
            { label: 'C', value: '', valuePlain: '' },
            { label: 'D', value: '', valuePlain: '' },
          ],
          correctAnswer: [],
        };

      case 'NUMERIC':
      case 'JEENUMERIC':

        return {
          ...baseData,
          answerType: 'exact',
          acceptableAnswers: '',
          min_value: '',
          max_value: '',
        };

      case 'PASSAGE_SINGLE':
        return {
          ...baseData,
          // passageTitle: '',
          passageText: '',
          options: [
            { label: 'A', value: '', valuePlain: '' },
            { label: 'B', value: '', valuePlain: '' },
            { label: 'C', value: '', valuePlain: '' },
            { label: 'D', value: '', valuePlain: '' },
          ],
          correctAnswer: '',
        };
      case 'PASSAGE_MULTI':
        return {
          assessmentType: [],
          questionType: 'PASSAGE_MULTI',
          difficultyTag: '',
          source: [],
          chapter: [],
          // passageTitle: '',
          passageText: '',
          questions: [
            {
              questionText: '',
              options: [
                { label: 'A', value: '', valuePlain: '' },
                { label: 'B', value: '', valuePlain: '' },
                { label: 'C', value: '', valuePlain: '' },
                { label: 'D', value: '', valuePlain: '' },
              ],
              correctAnswer: '',
              marks: '1',
              negativeMarks: '0',
              textExplanation: '',
              youtubeVideoUrl: '',
            },
          ],
        };

      case 'JEEPASSAGE':
        return {
          assessmentType: [],
          questionType: 'JEEPASSAGE',
          difficultyTag: '',
          source: [],
          chapter: [],
          // passageTitle: '',
          passageText: '',
          questions: [
            {
              questionText: '',
              options: [
                { label: 'A', value: '', valuePlain: '' },
                { label: 'B', value: '', valuePlain: '' },
                { label: 'C', value: '', valuePlain: '' },
                { label: 'D', value: '', valuePlain: '' },
              ],
              correctAnswer: '',
              marks: '1',
              negativeMarks: '0',
              textExplanation: '',
              youtubeVideoUrl: '',
            },
          ],
        };
      case 'CLATPASSAGE':
        return {
          assessmentType: [],
          questionType: 'CLATPASSAGE',
          difficultyTag: '',
          source: [],
          chapter: [],
          // passageTitle: '',
          passageText: '',
          questions: [
            {
              questionText: '',
              options: [
                { label: 'A', value: '', valuePlain: '' },
                { label: 'B', value: '', valuePlain: '' },
                { label: 'C', value: '', valuePlain: '' },
                { label: 'D', value: '', valuePlain: '' },
              ],
              correctAnswer: '',
              marks: '1',
              negativeMarks: '0',
              textExplanation: '',
              youtubeVideoUrl: '',
            },
          ],
        };

      default:
        return baseData;
    }
  };

  const [formData, setFormData] = useState(getInitialFormData(''));
  const [errors, setErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(true);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const prefillAppliedRef = useRef(false);
  const [snackbarType, setSnackbarType] = useState('error');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showQuestionInfo, setShowQuestionInfo] = useState(false);

  // Determine if we're in edit mode based on URL
  const isEditing = !!id;

  

  // Fetch all dropdown data on component mount
  useEffect(() => {
    fetchAllDropdowns();
  }, []);

  // Prefill source/chapter/category when coming from chapter questions
  useEffect(() => {
    if (isEditing) return;
    if (!prefillData || prefillAppliedRef.current) return;

    const {
      assessmentTypeId,
      assessmentTypeLabel,
      sourceId,
      sourceTitle,
      chapterId,
      chapterName,
    } = prefillData;

    if (sourceId || chapterId || assessmentTypeId || assessmentTypeLabel) {
      setFormData((prev) => ({
        ...prev,
        assessmentType: assessmentTypeId ? [String(assessmentTypeId)] : prev.assessmentType,
        source: sourceId ? [String(sourceId)] : prev.source,
        chapter: chapterId ? [String(chapterId)] : prev.chapter,
      }));

      if (assessmentTypeId) {
        setAssessmentTypes([
          {
            value: String(assessmentTypeId),
            label: assessmentTypeLabel || 'Selected category',
          },
        ]);
      }
      if (sourceId) {
        setSources([{
          value: String(sourceId),
          label: sourceTitle || 'Selected source',
          assessmentTypeIds: assessmentTypeId ? [String(assessmentTypeId)] : []
        }]);
      }
      if (chapterId) {
        setChapters([{ value: String(chapterId), label: chapterName || 'Selected chapter' }]);
      }

      if (assessmentTypeId) {
        fetchModules(assessmentTypeId);
      }
      if (sourceId) {
        fetchChapters(sourceId);
      }
    }

    prefillAppliedRef.current = true;
  }, [isEditing, prefillData]);


  useEffect(() => {
    if (isEditing) return;
    if (!prefillData?.assessmentTypeLabel) return;
    if ((formData.assessmentType || []).length > 0) return;
    if (!assessmentTypes.length) return;

    const match = assessmentTypes.find(
      (type) => type.label?.toLowerCase() === prefillData.assessmentTypeLabel?.toLowerCase()
    );
    if (match) {
      setFormData((prev) => ({
        ...prev,
        assessmentType: [match.value],
      }));
      fetchModules(match.value);
    }
  }, [isEditing, prefillData, assessmentTypes, formData.assessmentType]);

  // Load question data on mount if editing
  useEffect(() => {
    const loadQuestionData = async () => {
      if (id) {
        if (questionDataFromState) {
          populateFormWithQuestionData(questionDataFromState);
        } else {
          try {
            const result = await adminServices.getQuestionDetails(id);
            if (result?.data) {
              populateFormWithQuestionData(result.data);
            } else {
              setSnackbarTitle('Failed to load question details');
              setSnackbarType('error');
              setOpenSnackbar(true);
            }
          } catch (error) {
            console.error('Error fetching question details:', error);
            setSnackbarTitle('Error loading question details');
            setSnackbarType('error');
            setOpenSnackbar(true);
          }
        }
      }
    };

    loadQuestionData();
  }, [id, questionDataFromState]);

  // const populateFormWithQuestionData = async (questionData) => {
  //   console.log(questionData,"questionDataquestionData");


  //   if (Array.isArray(questionData) && questionData.length === 1 && (questionData[0].question_type !== 'PASSAGE_MULTI' || questionData[0].question_type !== 'JEEPASSAGE' || questionData[0].question_type !== 'CLATPASSAGE')) {
  //     questionData = questionData[0];
  //   }

  //   if (Array.isArray(questionData)) {
  //     const first = questionData[0];
  //     const questionTypeCode = 'PASSAGE_MULTI';

  //     // Find the question_type_id from questionTypes dropdown
  //     const passageMultiTypeEntry = Object.entries(questionTypeCodeMap).find(
  //       ([, code]) => code === 'PASSAGE_MULTI'
  //     );
  //     const questionTypeId = passageMultiTypeEntry ? passageMultiTypeEntry[0] : first.question_type_id ? String(first.question_type_id) : '';

  //     // Fetch dropdowns first
  //     try {
  //       if (Array.isArray(first.assessment_type_id) && first.assessment_type_id.length > 0) {
  //         const modulesResult = await adminServices.getModulesDropdown(first.assessment_type_id);
  //         if (modulesResult?.data?.data) {
  //           setSources(modulesResult.data.data.map(item => ({
  //             value: String(item.id),
  //             label: item.title || item.name,
  //             assessmentTypeIds: [String(item.assessment_type_id)]
  //           })));
  //         }
  //       }
  //       if (Array.isArray(first.assessment_source_id) && first.assessment_source_id.length > 0) {
  //         const chaptersResult = await adminServices.getChapterDropdown(first.assessment_source_id);
  //         if (chaptersResult?.data?.data) {
  //           setChapters(chaptersResult.data.data.map(item => ({
  //             value: String(item.id),
  //             label: item.module_name || item.name || item.title,
  //           })));
  //         }
  //       }
  //     } catch (err) {
  //       console.error('Error fetching dropdowns for PASSAGE_MULTI edit:', err);
  //     }

  //     // Map each sibling question into the sub-question structure
  //     const questions = questionData.map((q) => {
  //       const opts = q.options?.mcqOptions?.length
  //         ? q.options.mcqOptions.map((opt, idx) => ({
  //           label: String.fromCharCode(65 + idx),
  //           value: String(opt),
  //           valuePlain: '',
  //         }))
  //         : [
  //           { label: 'A', value: '', valuePlain: '' },
  //           { label: 'B', value: '', valuePlain: '' },
  //           { label: 'C', value: '', valuePlain: '' },
  //           { label: 'D', value: '', valuePlain: '' },
  //         ];

  //       const correctIndex = q.options?.correctAnswer?.findIndex(v => v === true);
  //       const correctAnswer = correctIndex >= 0 ? String.fromCharCode(65 + correctIndex) : '';

  //       return {
  //         id: q.id,
  //         questionText: q.question_text || '',
  //         options: opts,
  //         correctAnswer,
  //         marks: q.points?.toString() || '1',
  //         negativeMarks: q.options?.negativeMarks || '0',
  //         textExplanation: q.justification || '',
  //         youtubeVideoUrl: '',
  //       };
  //     });

  //     setFormData({
  //       assessmentType: first.assessment_type_id ? [String(first.assessment_type_id)] : [],
  //       questionType: questionTypeId,
  //       questionTypeCode,
  //       difficultyTag: first.level || '',
  //       source: first.assessment_source_id ? [String(first.assessment_source_id)] : [],
  //       chapter: first.chapter_id?.length > 0 ? first.chapter_id.map(String) : [],
  //       // passageTitle: '',
  //       passageText: first.passage || first.passage_text || '',
  //       passageId: first.passage_id || first.passage_table_id || null,
  //       questions,
  //     });

  //     return;
  //   }

  //   const questionTypeCode = questionData.question_type || questionData.question_type_description;

  //   if (typeof questionData?.options === 'string') {
  //     try {
  //       questionData = { ...questionData, options: JSON.parse(questionData?.options) };
  //     } catch (e) {
  //       console.error('Failed to parse options string:', e);
  //     }
  //   }

  //   const mappedFormData = {
  //     assessmentType: Array.isArray(questionData.assessment_type_id) && questionData.assessment_type_id.length > 0 ? questionData.assessment_type_id.map(String) : [],
  //     questionType: questionData.question_type_id ? String(questionData.question_type_id) : '',
  //     questionTypeCode: questionTypeCode,
  //     difficultyTag: questionData.level || '',
  //     source: Array.isArray(questionData.assessment_source_id) && questionData.assessment_source_id.length > 0 ? questionData.assessment_source_id.map(String) : [],
  //     chapter: questionData.chapter_id && questionData.chapter_id.length > 0
  //       ? questionData.chapter_id.map(String)
  //       : [],
  //     marks: questionData.points?.toString() || '1',
  //     negativeMarks: '0',
  //     questionText: questionData.question_text || '',
  //     textExplanation: questionData.justification || '',
  //     answerType: questionData.options?.answerType || '',
  //     acceptableAnswers: questionData.options?.acceptableAnswers || '',
  //     negativeMarks: questionData.options?.negativeMarks || '',
  //     youtubeVideoUrl: '',
  //     // passageTitle: '',
  //     passageText: questionData.passage || '',
  //   };


  //   // Initialize options array FIRST for all MCQ types
  //   if (questionTypeCode === 'MCQ' || questionTypeCode === 'JEEMCQ1' || questionTypeCode === 'JEEMCQ2' ||   questionTypeCode === 'MCQ_MULTI' || questionTypeCode === 'JEEPASSAGE' || questionTypeCode === 'CLATPASSAGE'  || questionTypeCode === 'PASSAGE_SINGLE') {
  //     mappedFormData.options = [
  //       { label: 'A', value: '', valuePlain: '' },
  //       { label: 'B', value: '', valuePlain: '' },
  //       { label: 'C', value: '', valuePlain: '' },
  //       { label: 'D', value: '', valuePlain: '' },
  //     ];
  //   }

  //   // if (questionTypeCode === 'MCQ' || questionTypeCode === 'PASSAGE_SINGLE' || questionTypeCode === 'Multiple Choice' ) {
  //   //   if (questionData.options?.mcqOptions && questionData.options.mcqOptions.length > 0) {
  //   //     mappedFormData.options = questionData.options.mcqOptions.map((opt, idx) => ({
  //   //       label: String.fromCharCode(65 + idx),
  //   //       value: opt,
  //   //       valuePlain: ''
  //   //     }));
  //   //   }

  //   //   const correctIndex = questionData.options?.correctAnswer?.findIndex(val => val === true);
  //   //   mappedFormData.correctAnswer = correctIndex >= 0 ? String.fromCharCode(65 + correctIndex) : '';
  //   // }

  //   if (questionTypeCode === 'MCQ' || questionTypeCode === 'JEEMCQ1' || questionTypeCode === 'PASSAGE_SINGLE' || questionTypeCode === 'Multiple Choice' || questionTypeCode === 'MCQ_MULTI'  || questionTypeCode === 'JEEPASSAGE' || questionTypeCode === 'CLATPASSAGE' || questionTypeCode === 'JEEMCQ2') {
  //     if (questionData.options?.mcqOptions?.length) {
  //       mappedFormData.options = questionData.options.mcqOptions.map((opt, idx) => ({
  //         label: String.fromCharCode(65 + idx),
  //         value: String(opt),
  //         valuePlain: ''
  //       }));

  //       const correctIndex = questionData.options.correctAnswer?.findIndex(v => v === true);
  //       mappedFormData.correctAnswer =
  //         correctIndex >= 0 ? String.fromCharCode(65 + correctIndex) : '';
  //     }

  //     else if (Array.isArray(questionData.options)) {
  //       mappedFormData.options = questionData.options;
  //       const match = questionData.justification?.match(/Option\s([A-Z])/i);
  //       mappedFormData.correctAnswer = match ? match[1] : '';
  //     }
  //   }


  //   if (questionTypeCode === 'MCQ_MULTI'  || questionTypeCode === 'JEEPASSAGE' || questionTypeCode === 'CLATPASSAGE' || questionTypeCode === 'JEEMCQ2' ) {
  //     if (questionData.options?.mcqOptions && questionData.options.mcqOptions.length > 0) {
  //       mappedFormData.options = questionData.options.mcqOptions.map((opt, idx) => ({
  //         label: String.fromCharCode(65 + idx),
  //         value: String(opt),
  //         valuePlain: ''
  //       }));
  //     }

  //     const correctAnswersArray = questionData.options?.correctAnswer
  //       ?.map((isCorrect, idx) => isCorrect ? String.fromCharCode(65 + idx) : null)
  //       .filter(Boolean);

  //     mappedFormData.correctAnswer = Array.isArray(correctAnswersArray) && correctAnswersArray.length > 0
  //       ? correctAnswersArray
  //       : [];
  //   }

  //   if (questionTypeCode === 'NUMERIC' || questionTypeCode === 'JEENUMERIC') {
  //     const answerType = (questionData.options?.answerType || 'exact').toString();
  //     mappedFormData.answerType = answerType;


  //     if (answerType === 'range') {
  //       mappedFormData.min_value = String(questionData.options?.minValue ?? questionData.options?.min_value ?? '');
  //       mappedFormData.max_value = String(questionData.options?.maxValue ?? questionData.options?.max_value ?? '');
  //       mappedFormData.acceptableAnswers = '';
  //     } else {
  //       mappedFormData.acceptableAnswers = questionData.reference_answer || questionData.options?.acceptableAnswers || questionData.options?.correctAnswer||'';
  //       mappedFormData.min_value = '';
  //       mappedFormData.max_value = '';
  //     }
  //   }
  //   try {
  //     if (mappedFormData.assessmentType.length > 0) {
  //       await fetchModulesForMultipleTypes(mappedFormData.assessmentType);
  //     }
  //     if (Array.isArray(questionData.assessment_source_id) && questionData.assessment_source_id.length > 0) {
  //       await fetchChaptersForMultipleSources(questionData.assessment_source_id.map(String));
  //     }
  //   } catch (error) {
  //     console.error('Error fetching dropdowns during edit:', error);
  //   }
  //   setFormData(mappedFormData);
  // };

  const populateFormWithQuestionData = async (questionData) => {
    console.log(questionData, "questionData");

    if (Array.isArray(questionData) && questionData.length === 1 && !['PASSAGE_MULTI', 'JEEPASSAGE', 'CLATPASSAGE'].includes(questionData[0].question_type)) {
      questionData = questionData[0];
    }


    if (Array.isArray(questionData)) {
      const first = questionData[0];
      const questionTypeCode = first.question_type || first.question_type_description || 'PASSAGE_MULTI';

      const passageMultiTypeEntry = Object.entries(questionTypeCodeMap).find(
        ([, code]) => code === questionTypeCode
      );

      const questionTypeId = passageMultiTypeEntry
        ? passageMultiTypeEntry[0]
        : first.question_type_id
          ? String(first.question_type_id)
          : '';

      try {
        if (first.assessment_type_id?.length) {
          const modulesResult = await adminServices.getModulesDropdown(
            first.assessment_type_id
          );
          if (modulesResult?.data?.data) {
            setSources(
              modulesResult.data.data.map((item) => ({
                value: String(item.id),
                label: item.title || item.name,
                assessmentTypeIds: [String(item.assessment_type_id)],
              }))
            );
          }
        }

        if (first.assessment_source_id?.length) {
          await fetchChaptersForMultipleSources(
            (Array.isArray(first.assessment_source_id)
              ? first.assessment_source_id
              : [first.assessment_source_id]
            ).map(String)
          );
        }
      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }

      const questions = questionData.map((q) => {
        const options =
          q.options?.mcqOptions?.map((opt, idx) => ({
            label: String.fromCharCode(65 + idx),
            value: String(opt),
            valuePlain: "",
          })) || [
            { label: "A", value: "", valuePlain: "" },
            { label: "B", value: "", valuePlain: "" },
            { label: "C", value: "", valuePlain: "" },
            { label: "D", value: "", valuePlain: "" },
          ];

        const correctAnswers =
          q.options?.correctAnswer
            ?.map((v, idx) => (v ? String.fromCharCode(65 + idx) : null))
            .filter(Boolean) || [];

        return {
          id: q.id,
          questionText: q.question_text || "",
          options,
          correctAnswer: correctAnswers.length === 1 ? correctAnswers[0] : correctAnswers,
          marks: q.points?.toString() || "1",
          negativeMarks: q.options?.negativeMarks || "0",
          textExplanation: q.justification || "",
          youtubeVideoUrl: "",
        };
      });

      setFormData({
        assessmentType: first.assessment_type_id
          ? [String(first.assessment_type_id)]
          : [],
        questionType: questionTypeId,
        questionTypeCode,
        difficultyTag: first.level || "",
        source: first.assessment_source_id
          ? [String(first.assessment_source_id)]
          : [],
        chapter: first.chapter_id?.map(String) || [],
        passageText: first.passage || first.passage_text || "",
        passageId: first.passage_id || first.passage_table_id || null,
        questions,
      });
      if (first.related_concept_tag) {
  setSelectedSuperAdminChapter(String(first.related_concept_tag));
}

      return;
    }

    let questionTypeCode =
      questionData.question_type || questionData.question_type_description;

    if (typeof questionData?.options === "string") {
      try {
        questionData.options = JSON.parse(questionData.options);
      } catch (e) {
        console.error("Options parse failed", e);
      }
    }

    const mappedFormData = {
      assessmentType: questionData.assessment_type_id?.map(String) || [],
      questionType: questionData.question_type_id ? String(questionData.question_type_id) : "",
      questionTypeCode,
      difficultyTag: questionData.level || "",
      source: questionData.assessment_source_id?.map(String) || [],
      chapter: questionData.chapter_id?.map(String) || [],
      marks: questionData.points?.toString() || "1",
      negativeMarks: questionData.options?.negativeMarks || "0",
      questionText: questionData.question_text || "",
      textExplanation: questionData.justification || "",
      youtubeVideoUrl: "",
      passageText: questionData.passage || "",
    };

    const singleTypes = ['MCQ', 'JEEMCQ1', 'PASSAGE_SINGLE', 'Multiple Choice'];
    const multiTypes = ['MCQ_MULTI', 'JEEMCQ2', 'JEEPASSAGE', 'CLATPASSAGE'];

    if ([...singleTypes, ...multiTypes].includes(questionTypeCode)) {
      mappedFormData.options =
        questionData.options?.mcqOptions?.map((opt, idx) => ({
          label: String.fromCharCode(65 + idx),
          value: String(opt),
          valuePlain: "",
        })) || [
          { label: "A", value: "", valuePlain: "" },
          { label: "B", value: "", valuePlain: "" },
          { label: "C", value: "", valuePlain: "" },
          { label: "D", value: "", valuePlain: "" },
        ];
    }

    if (singleTypes.includes(questionTypeCode)) {
      const idx = questionData.options?.correctAnswer?.findIndex((v) => v === true);
      mappedFormData.correctAnswer =
        idx >= 0 ? String.fromCharCode(65 + idx) : "";
    }

    if (multiTypes.includes(questionTypeCode)) {
      mappedFormData.correctAnswer =
        questionData.options?.correctAnswer
          ?.map((v, idx) => (v ? String.fromCharCode(65 + idx) : null))
          .filter(Boolean) || [];
    }

    if (['NUMERIC', 'JEENUMERIC'].includes(questionTypeCode)) {
      const answerType = questionData.options?.answerType || "exact";
      mappedFormData.answerType = answerType;

      if (answerType === "range") {
        mappedFormData.min_value =
          String(questionData.options?.minValue ?? "");
        mappedFormData.max_value =
          String(questionData.options?.maxValue ?? "");
      } else {
        mappedFormData.acceptableAnswers =
          questionData.reference_answer ||
          questionData.options?.acceptableAnswers ||
          questionData.options?.correctAnswer ||
          "";
      }
    }

    try {
      if (mappedFormData.assessmentType.length) {
        await fetchModulesForMultipleTypes(mappedFormData.assessmentType);
      }

      if (mappedFormData.source.length) {
        await fetchChaptersForMultipleSources(mappedFormData.source);
      }
    } catch (err) {
      console.error("Dropdown fetch error:", err);
    }

    setFormData(mappedFormData);
    if (questionData.related_concept_tag) {
      setSelectedSuperAdminChapter(String(questionData.related_concept_tag));
    }
  };

  const fetchAllDropdowns = async () => {
    setLoadingDropdowns(true);
    try {
      const assessmentTypeResult = await adminServices.getAssessmentTypeDropdown();
      if (assessmentTypeResult?.data?.data) {
        const formattedAssessmentTypes = assessmentTypeResult.data.data
          .filter(item => item.is_active)
          .map(item => ({
            value: String(item.id),
            label: item.code
          }));
        setAssessmentTypes(formattedAssessmentTypes);
      }

      const questionTypeResult = await adminServices.getQuestionTypeDropdown();
      if (questionTypeResult?.data?.data) {
        const codeMapping = {};
        const formattedQuestionTypes = questionTypeResult.data.data
          .filter(item => item.is_active === true)
          .map(item => {
            codeMapping[String(item.id)] = item.code;
            return {
              value: String(item.id),
              label: item.code,
              display: item.description

            };
          });
        setQuestionTypes(formattedQuestionTypes);
        setQuestionTypeCodeMap(codeMapping);
      }
    } catch (error) {
      console.error('Error fetching dropdowns:', error);
      setSnackbarTitle('Error loading dropdown options');
      setSnackbarType('error');
      setOpenSnackbar(true);
    } finally {
      setLoadingDropdowns(false);
    }
  };

  const fetchModules = async (assessmentTypeId) => {
    try {
      const result = await adminServices.getModulesDropdown(assessmentTypeId);
      if (result?.data?.data) {
        const formattedSources = result.data.data.map(item => ({
          value: String(item.id),
          label: item.title || item.name,
          assessmentTypeIds: [String(item.assessment_type_id)]
        }));

        setSources(prevSources => {
          const sourceMap = {};
          [...prevSources, ...formattedSources].forEach(source => {
            sourceMap[source.value] = source;
          });
          return Object.values(sourceMap);
        });
      }
    } catch (error) {
      console.error('Error fetching modules:', error);
      setSnackbarTitle('Error loading modules');
      setSnackbarType('error');
      setOpenSnackbar(true);
    }
  };

  const fetchChapters = async (sourceId) => {
    try {
      const result = await adminServices.getChapterDropdown(sourceId);
      if (result?.data?.data) {
        const formattedChapters = result.data.data.map(item => ({
          value: String(item.id),
          label: item.module_name || item.name || item.title,
          sourceIds: [String(sourceId)]
        }));

        setChapters(prevChapters => {
          const chapterMap = {};
          [...prevChapters, ...formattedChapters].forEach(chapter => {
            chapterMap[chapter.value] = chapter;
          });
          return Object.values(chapterMap);
        });
      }
    } catch (error) {
      console.error('Error fetching chapters:', error);
      setSnackbarTitle('Error loading chapters');
      setSnackbarType('error');
      setOpenSnackbar(true);
    }
  };

  const handleQuestionTypeChange = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const selectedId = e.target.value;
    const questionTypeCode = questionTypeCodeMap[selectedId];
    console.log(questionTypeCode, "questionTypeCodequestionTypeCode");

    const newFormData = getInitialFormData(questionTypeCode);
    console.log(newFormData, "newFormDatanewFormData");


    if (formData.assessmentType?.length) newFormData.assessmentType = formData.assessmentType;
    if (formData.difficultyTag) newFormData.difficultyTag = formData.difficultyTag;
    if (formData.source?.length) newFormData.source = formData.source;
    if (formData.chapter?.length) newFormData.chapter = formData.chapter;
    if (formData.marks) newFormData.marks = formData.marks;
    if (formData.negativeMarks) newFormData.negativeMarks = formData.negativeMarks;

    newFormData.questionType = selectedId;
    newFormData.questionTypeCode = questionTypeCode;

    setFormData(newFormData);
    setErrors({});
  };

  const handleBasicFieldChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFormData(prev => {
      const updated = { ...prev, [name]: value };
      return updated;
    });

    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const toggleMultiSelect = (field, value, relatedResets = {}) => {
    setFormData(prev => {
      const current = prev[field] || [];
      const isSelected = current.includes(value);
      const updated = isSelected ? current.filter(v => v !== value) : [...current, value];
      return { ...prev, [field]: updated, ...relatedResets };
    });
    if (errors[field]) {
      setErrors(prev => { const e = { ...prev }; delete e[field]; return e; });
    }
  };

  const fetchModulesForMultipleTypes = async (assessmentTypeIds) => {
    try {
      const sourcesPromises = assessmentTypeIds.map(id =>
        adminServices.getModulesDropdown(id)
      );
      const results = await Promise.all(sourcesPromises);
      const allSources = {};
      results.forEach((result) => {
        if (result?.data?.data) {
          result.data.data.forEach(item => {
            const value = String(item.id);
            const belongsToTypeId = String(item.assessment_type_id);
            if (!allSources[value]) {
              allSources[value] = {
                value,
                label: item.title || item.name,
                assessmentTypeIds: [belongsToTypeId]
              };
            } else {
              if (!allSources[value].assessmentTypeIds.includes(belongsToTypeId)) {
                allSources[value].assessmentTypeIds.push(belongsToTypeId);
              }
            }
          });
        }
      });

      setSources(Object.values(allSources));
    } catch (error) {
      console.error('Error fetching modules for multiple types:', error);
      setSnackbarTitle('Error loading modules');
      setSnackbarType('error');
      setOpenSnackbar(true);
    }
  };

  const handleAssessmentTypeToggle = (value) => {
    const current = formData.assessmentType || [];
    const isSelected = current.includes(value);
    const updated = isSelected ? current.filter(v => v !== value) : [...current, value];

    if (updated.length > 0) {
      fetchModulesForMultipleTypes(updated);
    } else {
      setSources([]);
      setChapters([]);
    }

    setFormData(prev => {
      const remainingSources = isSelected
        ? prev.source.filter(srcId => {
          const srcData = sources.find(s => String(s.value) === String(srcId));
          if (!srcData) return true;
          return srcData.assessmentTypeIds?.some(id => updated.includes(String(id)));
        })
        : prev.source;

      const remainingChapters = isSelected
        ? prev.chapter.filter(chapId => {
          const chapData = chapters.find(c => String(c.value) === String(chapId));
          if (!chapData) return true;
          return chapData.sourceIds?.some(id => remainingSources.includes(String(id)));
        })
        : prev.chapter;

      return {
        ...prev,
        assessmentType: updated,
        source: updated.length === 0 ? [] : remainingSources,
        chapter: updated.length === 0 ? [] : remainingChapters,
      };
    });

    if (errors.assessmentType) {
      setErrors(prev => { const e = { ...prev }; delete e.assessmentType; return e; });
    }
  };

  const fetchChaptersForMultipleSources = async (sourceIds) => {
    try {
      const chaptersPromises = sourceIds.map(id => adminServices.getChapterDropdown(id));
      const results = await Promise.all(chaptersPromises);
      const allChapters = {};
      results.forEach((result, index) => {
        if (result?.data?.data) {
          result.data.data.forEach(item => {
            const value = String(item.id);
            if (!allChapters[value]) {
              allChapters[value] = {
                value,
                label: item.module_name || item.name || item.title,
                sourceIds: [String(sourceIds[index])]
              };
            } else {
              if (!allChapters[value].sourceIds.includes(String(sourceIds[index]))) {
                allChapters[value].sourceIds.push(String(sourceIds[index]));
              }
            }
          });
        }
      });
      setChapters(Object.values(allChapters));
    } catch (error) {
      console.error('Error fetching chapters for multiple sources:', error);
      setSnackbarTitle('Error loading chapters');
      setSnackbarType('error');
      setOpenSnackbar(true);
    }
  };

  const handleSourceToggle = (value) => {
    const current = formData.source || [];
    const isSelected = current.includes(value);
    const updated = isSelected ? current.filter(v => v !== value) : [...current, value];

    if (updated.length > 0) {
      fetchChaptersForMultipleSources(updated);
    } else {
      setChapters([]);
    }

    setFormData(prev => ({
      ...prev,
      source: updated,
      chapter: isSelected
        ? prev.chapter.filter(chapId => {
          const chap = chapters.find(c => String(c.value) === String(chapId));
          if (!chap) return false;
          return chap.sourceIds?.some(sid => updated.includes(String(sid)));
        })
        : prev.chapter,
    }));

    if (errors.source) {
      setErrors(prev => { const e = { ...prev }; delete e.source; return e; });
    }
  };

  const handleChapterToggle = (value) => {
    toggleMultiSelect('chapter', value);
  };

  const handleSelectAll = (field, allValues) => {
    setFormData(prev => ({
      ...prev,
      [field]: allValues,
      ...(field === 'assessmentType' && { source: [], chapter: [] }),
      ...(field === 'source' && { chapter: [] })
    }));

    if (!allValues.length) return;

    if (field === 'assessmentType')
      allValues.forEach(fetchModules);

    if (field === 'source')
      allValues.forEach(fetchChapters);
  };

  const handleDeselectAll = (field) => {
    setFormData(prev => ({ ...prev, [field]: [] }));

    if (field === 'assessmentType') {
      setSources([]);
      setChapters([]);
    }

    if (field === 'source') {
      setChapters([]);
    }
  };



  // Helper function to focus on first error field
  const focusOnFirstError = (errorPath) => {
    setTimeout(() => {
      // Handle nested paths like "options.0.value" or "questions.0.questionText"
      const pathParts = errorPath.split('.');
      const fieldName = pathParts[0];

      // Try to find the element by ID or name
      const element = document.getElementById(fieldName) ||
        document.querySelector(`[name="${fieldName}"]`) ||
        document.querySelector(`[data-error-field="${fieldName}"]`);

      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.focus();
      } else {
        console.warn('Could not find element for field:', fieldName);
        // Try to scroll to the general area
        const errorElement = document.querySelector('.text-red-600');
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }, 100);
  };

  // Add this debugging in your validateForm function:

  const validateForm = () => {
    const questionTypeCode = questionTypeCodeMap[formData.questionType];

    if (!questionTypeCode) {
      return false;
    }

    const schema = getValidationSchema(questionTypeCode);

    // Transform data for validation - replace ID with CODE
    const dataToValidate = {
      ...formData,
      questionType: questionTypeCode
    };
    const result = schema.safeParse(dataToValidate);

    if (!result.success) {
      const formattedErrors = {};

      // Zod uses 'issues', not 'errors'
      result.error.issues.forEach((issue) => {
        const path = issue.path.join('.');
        formattedErrors[path] = issue.message;
      });
      setErrors(formattedErrors);

      // Focus on first error
      if (result.error.issues.length > 0) {
        const firstErrorPath = result.error.issues[0].path.join('.');
        focusOnFirstError(firstErrorPath);
      }

      return false;
    }
    setErrors({});
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(validateForm(), "5555555555555");

    if (!validateForm()) {
      return;
    }

    try {
      setIsSubmitting(true);
      const questionTypeCode = questionTypeCodeMap[formData.questionType];

      let apiData;

      if (questionTypeCode === 'PASSAGE_MULTI' || questionTypeCode === 'JEEPASSAGE' || questionTypeCode === 'CLATPASSAGE') {
        apiData = {
          superAdminChapter: selectedSuperAdminChapter || null,
          questionType: formData.questionType,
          questionTypeCode: questionTypeCode,
          difficultyTag: formData.difficultyTag,
          assessmentType: formData.assessmentType,
          source: formData.source,
          chapter: formData.chapter,
          // passageTitle: formData.passageTitle,
          passageText: formData.passageText,
          passageId: formData.passageId || null,
          questions: formData.questions
        };
      } else if (questionTypeCode === 'NUMERIC' || questionTypeCode === 'JEENUMERIC') {
        apiData = {
          questionText: formData.questionText,
          superAdminChapter: selectedSuperAdminChapter || null,
          questionType: formData.questionType,
          questionTypeCode: questionTypeCode,
          difficultyTag: formData.difficultyTag,
          marks: formData.marks,
          negativeMarks: formData.negativeMarks,
          assessmentType: formData.assessmentType,
          source: formData.source,
          chapter: formData.chapter,
          answerType: formData.answerType,
          textExplanation: formData.textExplanation,
          youtubeVideoUrl: formData.youtubeVideoUrl,
          ...(formData.answerType === 'range'
            ? { min_value: formData.min_value, max_value: formData.max_value }
            : { acceptableAnswers: formData.acceptableAnswers }
          ),
        };
      } else {
        apiData = {
          questionText: formData.questionText,
          superAdminChapter: selectedSuperAdminChapter || null,
          questionType: formData.questionType,
          questionTypeCode: questionTypeCode,
          difficultyTag: formData.difficultyTag,
          marks: formData.marks,
          negativeMarks: formData.negativeMarks,
          assessmentType: formData.assessmentType,
          source: formData.source,
          chapter: formData.chapter,
          options: formData.options,
          correctAnswer: formData.correctAnswer || formData.correctAnswers,
          textExplanation: formData.textExplanation,
          youtubeVideoUrl: formData.youtubeVideoUrl,
          passageText: formData.passageText || null,
          // passageTitle: formData.passageTitle || null,
        };
      }
      console.log(apiData, "apiData");

      const result = isEditing
        ? await adminServices.updateQuestion(id, apiData)
        : await adminServices.createQuestions(apiData);


      if (result.ok) {
        const data = result.data;
        if (data?.skippedQuestions?.length > 0) {
          setSnackbarTitle(data.message);
          setSnackbarType('warning');
        } else {
          setSnackbarTitle(isEditing ? 'Question updated successfully!' : 'Question created successfully!');
          setSnackbarType('success');
        }
        setOpenSnackbar(true);

        // if (!isEditing) {

        const chapterId = fromChapterId || (resolvedPrefill ? resolvedPrefill?.chapterId : (questionDataFromState?.length > 0 ? questionDataFromState[0]?.chapter_id?.[0] : questionDataFromState?.chapter_id?.[0]));
        setTimeout(() => {
          const target = fromChapterPage && chapterId
            ? `/app/chapter-questions/${chapterId}`
            : '/app/questions';
          // const target = resolvedPrefill?.chapterId || questionDataFromState?.chapter_id[0]
          // ? `/app/chapter-questions/${resolvedPrefill.chapterId || questionDataFromState?.chapter_id[0] }`
          // : '/app/questions';
          navigate(target);
          setIsSubmitting(false);
        }, 1500);

        // return;
        // }
      }
    } catch (error) {
      console.error('Error saving question:', error);
      setSnackbarTitle(isEditing ? ' Failed to update question. Please try again.' : ' Failed to create question. Please try again.');
      setSnackbarType('error');
      setOpenSnackbar(true);
      setIsSubmitting(false);

    }
  };

  const handleCancel = () => {
    setFormData(getInitialFormData(''));
    setErrors({});
    setSources([]);
    setChapters([]);
    if (fromChapterPage && chapterBackId) {
      navigate(`/app/chapter-questions/${chapterBackId}`);
    } else {
      navigate('/app/questions');
    }
  };

  const renderQuestionTypeComponent = () => {
    const questionTypeCode = questionTypeCodeMap[formData.questionType];

    if (isEditMode) {
      switch (questionTypeCode) {
        case 'MCQ':
          return <MCQSingleSelect formData={formData} setFormData={setFormData} errors={errors} setErrors={setErrors} />;
        case 'JEEMCQ1':
          return <MCQSingleSelect formData={formData} setFormData={setFormData} errors={errors} setErrors={setErrors} />;
        case 'MCQ_MULTI':
          return <MCQMultipleSelect formData={formData} setFormData={setFormData} errors={errors} setErrors={setErrors} />;
        case 'JEEMCQ2':
          return <MCQMultipleSelect formData={formData} setFormData={setFormData} errors={errors} setErrors={setErrors} />;
        case 'NUMERIC':
          return <NumericAnswer formData={formData} setFormData={setFormData} errors={errors} setErrors={setErrors} />;
        case 'JEENUMERIC':
          return <NumericAnswer formData={formData} setFormData={setFormData} errors={errors} setErrors={setErrors} />;
        case 'PASSAGE_SINGLE':
          return <PassageSingleQuestion formData={formData} setFormData={setFormData} errors={errors} setErrors={setErrors} />;

        case 'PASSAGE_MULTI':
        case 'JEEPASSAGE':
        case 'CLATPASSAGE':
          return <PassageMultipleQuestions formData={formData} setFormData={setFormData} errors={errors} setErrors={setErrors} />;

        default:
          return (
            <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
              <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h3 className="mt-2 text-sm font-medium text-gray-900">Select a question type to begin</h3>
              <p className="mt-1 text-sm text-gray-500">Choose a question type from the dropdown above</p>
            </div>
          );
      }
    } else {
      return <PreviewMode formData={formData} questionTypeCode={questionTypeCode} />;
    }
  };

  const isSourceChapterLocked = !isEditing && !!(prefillData?.sourceId && prefillData?.chapterId);
  const isAssessmentTypeLocked = isSourceChapterLocked && !!(prefillData?.assessmentTypeId || prefillData?.assessmentTypeLabel);

  const effectiveAssessmentTypes =
    (formData.assessmentType || []).some(id => !assessmentTypes.some(t => String(t.value) === id))
      ? [...assessmentTypes, ...(formData.assessmentType || [])
        .filter(id => !assessmentTypes.some(t => String(t.value) === id))
        .map(id => ({ value: id, label: prefillData?.assessmentTypeLabel || 'Selected category' }))]
      : assessmentTypes;

  const _questionSourceNames = Array.isArray(questionDataFromState)
    ? questionDataFromState[0]?.source_names
    : questionDataFromState?.source_names;

  const effectiveSources =
    (formData.source || []).some(id => !sources.some(s => String(s.value) === id))
      ? [...sources, ...(formData.source || [])
        .filter(id => !sources.some(s => String(s.value) === id))
        .map((id, i) => ({
          value: id,
          label: _questionSourceNames?.[i]
            || prefillData?.sourceTitle
            || 'Selected source',
        }))]
      : sources;

  const effectiveChapters = (formData.source || []).length === 0 ? [] : chapters.filter(chapter =>
    chapter.sourceIds?.some(sid => (formData.source || []).includes(String(sid)))
  );

  const chapterBackId = fromChapterId || resolvedPrefill?.chapterId || (questionDataFromState?.length > 0 ? questionDataFromState[0]?.chapter_id?.[0] : questionDataFromState?.chapter_id?.[0]);
  const backButtonLabel = fromChapterPage ? 'Back to Chapter' : 'Back to Question List';
  const isFromChapterFlow = fromChapterPage;
  const prefillSourceTitle = resolvedPrefill?.sourceTitle || '';
  const prefillChapterName = resolvedPrefill?.chapterName || '';

  const handleBackNavigation = () => {
    if (fromChapterPage && chapterBackId) {
      navigate(`/app/chapter-questions/${chapterBackId}`);
      return;
    }
    navigate('/app/questions');
  };



  return (
    <Page title={isEditing ? "Edit Question" : "Create New Question"}>
      <div className="px-4 sm:px-6 lg:px-8 py-8 mx-auto">
        <div id="question-form-header-nav" className="mb-6 flex flex-wrap items-center gap-3">
          <button
            id="question-form-back-btn"
            type="button"
            onClick={handleBackNavigation}
            className="inline-flex items-center text-sm text-gray-600 hover:text-gray-900 transition-colors duration-150"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            {backButtonLabel}
          </button>

          {isFromChapterFlow && (prefillSourceTitle || prefillChapterName) && (
            <div id="question-form-breadcrumb" className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-1.5 text-sm text-gray-700">
              {prefillSourceTitle && (
                <span className="inline-flex items-center gap-1.5 font-medium text-gray-800">
                  <BookOpen size={14} className="text-gray-600" />
                  {prefillSourceTitle}
                </span>
              )}
              {prefillSourceTitle && prefillChapterName && (
                <span className="text-gray-400">{'>'}</span>
              )}
              {prefillChapterName && (
                <span className="inline-flex items-center gap-1.5 font-medium text-gray-800">
                  <FileText size={14} className="text-gray-600" />
                  {prefillChapterName}
                </span>
              )}
            </div>
          )}
        </div>

        {/* Header */}
        <div id="question-form-title-section" className="mb-6">
          <h2 id="question-form-title" className="text-2xl font-bold text-gray-900">{isEditing ? "Edit Question" : "Create New Question"}</h2>
          <p id="question-form-subtitle" className="mt-1 text-sm text-gray-500">
            {isEditing ? "Update your question details" : "Build questions for your assessments"}
          </p>
        </div>

        {/* Mode Toggle */}
        <div id="question-form-mode-toggle" className="mb-6 flex items-center gap-4 bg-white rounded-lg border border-gray-200 p-1 inline-flex">
          <button
            id="question-form-edit-mode-btn"
            type="button"
            onClick={() => setIsEditMode(true)}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors duration-150 ${isEditMode
              ? 'bg-indigo-600 text-white'
              : 'text-gray-700 hover:bg-gray-100'
              }`}
          >
            Edit Mode
          </button>
          <button
            id="question-form-preview-mode-btn"
            type="button"
            onClick={() => setIsEditMode(false)}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors duration-150 ${!isEditMode
              ? 'bg-indigo-600 text-white'
              : 'text-gray-700 hover:bg-gray-100'
              }`}
          >
            Preview Mode
          </button>
        </div>


        {loadingDropdowns ? (
          <div id="question-form-loading" className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
            <p className="mt-2 text-sm text-gray-600">Loading options...</p>
          </div>
        ) : (
          <form id="question-create-form" ref={formRef} onSubmit={handleSubmit} className="space-y-6">
            {/* Question Information - Only show in edit mode */}
            {isEditing && questionDataFromState && (
              <div id="question-info-section" className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <button
                  id="question-info-toggle-btn"
                  type="button"
                  onClick={() => setShowQuestionInfo(!showQuestionInfo)}
                  className="w-full px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors duration-150"
                >
                  <h3 className="text-lg font-medium text-gray-900">Question Information</h3>
                  <svg
                    className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${showQuestionInfo ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                {showQuestionInfo && (
                  <div className="px-6 pb-4 border-t border-gray-200">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                      <div className="flex items-center gap-2 text-sm">
                        <svg className="w-4 h-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                        </svg>
                        <span className="text-gray-600">Created by:</span>
                        <span className="font-medium text-gray-900">
                          {
                            Array.isArray(questionDataFromState)
                              ? (questionDataFromState[0]?.email || 'N/A')
                              : (questionDataFromState?.email || 'N/A')
                          }
                        </span>
                      </div>

                      <div className="flex items-center gap-2 text-sm">
                        <svg className="w-4 h-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                        </svg>
                        <span className="text-gray-600">Created:</span>
                        <span className="font-medium text-gray-900">
                          {/* {questionDataFromState.created_date
                            ? new Date(questionDataFromState.created_date).toLocaleString('en-US', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            })
                            : 'N/A'} */}
                          {
                            (
                              Array.isArray(questionDataFromState)
                                ? questionDataFromState[0]?.created_date
                                : questionDataFromState?.created_date
                            )
                              ? new Date(
                                Array.isArray(questionDataFromState)
                                  ? questionDataFromState[0]?.created_date
                                  : questionDataFromState?.created_date
                              ).toLocaleString('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })
                              : 'N/A'
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {isEditMode && <div id="question-basic-info-card" className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-medium text-gray-900 mb-4">Basic Information</h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Categories (Assessment Types) - Multi-select checkbox list */}
                <div className="md:col-span-2">
                  <div>
                    <div className="flex items-center justify-between mb-2">
                      <label className="block text-sm font-medium text-gray-700">
                        Categories <span className="text-red-500">*</span>
                      </label>
                      <div className="flex gap-3 text-sm">
                        {/* <button
                          type="button"
                           className="text-xs text-indigo-600 hover:text-indigo-700 font-medium px-2.5 py-1 rounded-full border border-indigo-200 hover:bg-indigo-50 transition-colors"
                          onClick={() => handleSelectAll('assessmentType', effectiveAssessmentTypes.map(t => String(t.value)))}                        >
                          Select All
                        </button> */}
                        <button
                          id="question-form-assessment-type-deselect-btn"
                          type="button"
                          className="text-xs text-indigo-600 hover:text-indigo-700 font-medium px-2.5 py-1 rounded-full border border-indigo-200 hover:bg-indigo-50 transition-colors"
                          onClick={() => handleDeselectAll('assessmentType')}
                        >
                          Deselect All
                        </button>
                      </div>
                    </div>
                    <div
                      id="question-form-assessment-type-list"
                      className="max-h-40 overflow-y-auto border border-gray-200 rounded p-2 space-y-1"
                      style={{ scrollbarWidth: 'thin' }}
                    >
                      {effectiveAssessmentTypes.length === 0 && (
                        <p className="text-sm text-gray-400 px-1">Loading categories...</p>
                      )}
                      {effectiveAssessmentTypes.map((type) => (
                        <label
                          key={type.value}
                          className={`flex items-center gap-2 px-1 py-1 rounded cursor-pointer hover:bg-gray-50 text-sm ${isAssessmentTypeLocked ? 'opacity-60 pointer-events-none' : ''}`}
                        >
                          <input
                            id={`question-form-assessment-type-checkbox-${type.value}`}
                            type="checkbox"
                            className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                            checked={(formData.assessmentType || []).includes(String(type.value))}
                            onChange={() => handleAssessmentTypeToggle(String(type.value))}
                            disabled={isAssessmentTypeLocked}
                          />
                          <span className="text-gray-800">{type.label}</span>
                        </label>
                      ))}
                    </div>
                    {errors.assessmentType && (
                      <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.assessmentType}
                      </p>
                    )}
                  </div>
                </div>

                {/* Sources & Chapters - Side-by-side multi-select */}
                <div className="md:col-span-2">
                  <div className="border border-gray-200 rounded-lg overflow-hidden">
                    <div className="bg-indigo-600 text-white text-sm font-semibold px-4 py-2">
                      Sources &amp; Chapters
                    </div>
                    <div className="grid grid-cols-2 divide-x divide-gray-200">
                        {/* Sources */}
                        <div className="p-3">
                          <div className="flex items-center justify-between gap-2 mb-2">
                            <span className="text-sm font-medium text-gray-700 whitespace-nowrap">Sources</span>
                            <input
                              id="question-form-source-search"
                              type="text"
                              placeholder="Search sources..."
                              value={sourceSearch}
                              onChange={(e) => setSourceSearch(e.target.value)}
                              className="flex-1 px-2 py-1 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-400"
                            />
                            <button
                              id="question-form-source-deselect-btn"
                              type="button"
                              className="text-xs text-indigo-600 hover:text-indigo-700 font-medium px-2.5 py-1 rounded-full border border-indigo-200 hover:bg-indigo-50 transition-colors whitespace-nowrap"
                              onClick={() => handleDeselectAll('source')}
                            >
                              Deselect All
                            </button>
                          </div>
                        <div
                          id="question-form-source-list"
                          className="max-h-44 overflow-y-auto space-y-1"
                          style={{ scrollbarWidth: 'thin' }}
                        >
                          {(formData.assessmentType || []).length === 0 && (
                            <p className="text-xs text-gray-400 px-1">Select a category first</p>
                          )}
                          {(formData.assessmentType || []).length > 0 && effectiveSources.length === 0 && (
                            <p className="text-xs text-gray-400 px-1">No sources available</p>
                          )}
                          {effectiveSources.length > 0 && sourceSearch &&
                            effectiveSources.filter(s => (s.label || '').toLowerCase().includes(sourceSearch.toLowerCase())).length === 0 && (
                              <p className="text-xs text-gray-400 px-1">No sources found for "{sourceSearch}"</p>
                          )}
                          {effectiveSources
                            .filter(s => (s.label || '').toLowerCase().includes(sourceSearch.toLowerCase()))
                            .map((source) => (
                            <label
                              key={source.value}
                              className={`flex items-center gap-2 px-1 py-1 rounded cursor-pointer hover:bg-gray-50 text-sm ${isSourceChapterLocked ? 'opacity-60 pointer-events-none' : ''}`}
                            >
                              <input
                                id={`question-form-source-checkbox-${source.value}`}
                                type="checkbox"
                                className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                checked={(formData.source || []).includes(String(source.value))}
                                onChange={() => handleSourceToggle(String(source.value))}
                                disabled={isSourceChapterLocked}
                              />
                              <span className="text-gray-800">{source.label}</span>
                            </label>
                          ))}
                        </div>
                        {errors.source && (
                          <p className="mt-1 text-xs text-red-600">{errors.source}</p>
                        )}
                      </div>

                      {/* Chapters */}
                        <div className="p-3">
                          <div className="flex items-center justify-between gap-2 mb-2">
                            <span className="text-sm font-medium text-gray-700 whitespace-nowrap">Chapters</span>
                            <input
                              id="question-form-chapter-search"
                              type="text"
                              placeholder="Search chapters..."
                              value={chapterSearch}
                              onChange={(e) => setChapterSearch(e.target.value)}
                              className="flex-1 px-2 py-1 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-400"
                            />
                            <button
                              id="question-form-chapter-deselect-btn"
                              type="button"
                              className="text-xs text-indigo-600 hover:text-indigo-700 font-medium px-2.5 py-1 rounded-full border border-indigo-200 hover:bg-indigo-50 transition-colors whitespace-nowrap"
                              onClick={() => handleDeselectAll('chapter')}
                            >
                              Deselect All
                            </button>
                          </div>
                        <div
                          id="question-form-chapter-list"
                          className="max-h-44 overflow-y-auto space-y-1"
                          style={{ scrollbarWidth: 'thin' }}
                        >
                          {(formData.source || []).length === 0 && (
                            <p className="text-xs text-gray-400 px-1">Select a source first</p>
                          )}
                          {(formData.source || []).length > 0 && effectiveChapters.length === 0 && (
                            <p className="text-xs text-gray-400 px-1">No chapters available</p>
                          )}
                          {effectiveChapters.length > 0 && chapterSearch &&
                            effectiveChapters.filter(c => (c.label || '').toLowerCase().includes(chapterSearch.toLowerCase())).length === 0 && (
                              <p className="text-xs text-gray-400 px-1">No chapters found for "{chapterSearch}"</p>
                          )}
                            {effectiveChapters
                              .filter(c => (c.label || '').toLowerCase().includes(chapterSearch.toLowerCase()))
                              .map((chapter) => (
                            <label
                              key={chapter.value}
                              className={`flex items-center gap-2 px-1 py-1 rounded cursor-pointer hover:bg-gray-50 text-sm ${isSourceChapterLocked ? 'opacity-60 pointer-events-none' : ''}`}
                            >
                              <input
                                id={`question-form-chapter-checkbox-${chapter.value}`}
                                type="checkbox"
                                className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                checked={(formData.chapter || []).includes(String(chapter.value))}
                                onChange={() => handleChapterToggle(String(chapter.value))}
                                disabled={isSourceChapterLocked}
                              />
                              <span className="text-gray-800">{chapter.label}</span>
                            </label>
                          ))}
                        </div>
                        {errors.chapter && (
                          <p className="mt-1 text-xs text-red-600">{errors.chapter}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Question Type */}
                <div>
                  <label htmlFor="questionType" className="block text-sm font-medium text-gray-700 mb-1">
                    Question Type <span className="text-red-500">*</span>
                  </label>
                  <select disabled={isEditing}
                    id="questionType"
                    name="questionType"
                    value={formData.questionType}
                    onChange={handleQuestionTypeChange}
                    data-error-field="questionType"
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm ${errors.questionType ? 'border-red-500 bg-red-50' : 'border-gray-300'
                      }`}
                  >
                    <option value="">Select question type</option>
                    {questionTypes.map((type) => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </select>
                  {errors.questionType && (
                    <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                      </svg>
                      {errors.questionType}
                    </p>
                  )}
                </div>

                {/* Difficulty Tag */}
                <div>
                  <label htmlFor="difficultyTag" className="block text-sm font-medium text-gray-700 mb-1">
                    Difficulty Tag <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="difficultyTag"
                    name="difficultyTag"
                    value={formData.difficultyTag}
                    onChange={handleBasicFieldChange}
                    data-error-field="difficultyTag"
                    className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm ${errors.difficultyTag ? 'border-red-500 bg-red-50' : 'border-gray-300'
                      }`}
                  >
                    <option value="">Select difficulty</option>
                    {difficultyTags.map((tag) => (
                      <option key={tag.value} value={tag.value}>
                        {tag.label}
                      </option>
                    ))}
                  </select>
                  {errors.difficultyTag && (
                    <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                      </svg>
                      {errors.difficultyTag}
                    </p>
                  )}
                </div>



                {/* {(!['PASSAGE_MULTI', 'JEEPASSAGE', 'CLATPASSAGE'].includes(questionTypeCodeMap[formData.questionType])) && ( */}
                  <div>
                    <label htmlFor="marks" className="block text-sm font-medium text-gray-700 mb-1">
                      Marks <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="marks"
                      name="marks"
                      value={formData.marks}
                      onChange={handleBasicFieldChange}
                      data-error-field="marks"
                      className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm ${errors.marks ? 'border-red-500 bg-red-50' : 'border-gray-300'
                        }`}
                    />
                    {errors.marks && (
                      <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.marks}
                      </p>
                    )}
                  </div>
                {/* )} */}

                {/* {(!['PASSAGE_MULTI', 'JEEPASSAGE', 'CLATPASSAGE'].includes(questionTypeCodeMap[formData.questionType])) && ( */}
                  <div>
                    <label htmlFor="negativeMarks" className="block text-sm font-medium text-gray-700 mb-1">
                      Negative Marks
                    </label>
                    <input
                      type="text"
                      id="negativeMarks"
                      name="negativeMarks"
                      value={formData.negativeMarks}
                      onChange={handleBasicFieldChange}
                      data-error-field="negativeMarks"
                      className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm ${errors.negativeMarks ? 'border-red-500 bg-red-50' : 'border-gray-300'
                        }`}
                    />
                    {errors.negativeMarks && (
                      <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {errors.negativeMarks}
                      </p>
                    )}
                  </div>
                   

                {/* )} */}
              </div>
            </div>}

            {formData.questionType && (
              <div id="question-form-type-component-card" className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                {renderQuestionTypeComponent()}
              </div>
            )}

            {formData.questionType && (
              <div id="question-form-actions" className="flex items-center justify-end gap-4">
                <button
                  id="question-form-cancel-btn"
                  type="button"
                  onClick={handleCancel}
                  disabled={isSubmitting}
                  className="px-6 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors duration-150"
                >
                  Cancel
                </button>
                <button
                  id="question-form-submit-btn"
                  type="submit"
                  disabled={isSubmitting}
                  className="px-6 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg transition-colors duration-150 shadow-sm disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? (
                    <span className="inline-flex items-center gap-2">
                      <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                      Saving...
                    </span>
                  ) : (
                    isEditing ? 'Update Question' : 'Save Question'
                  )}
                </button>
              </div>
            )}
          </form>
        )}
      </div>

      {/* Snackbar - Now positioned at top */}
      <SnackBar
        open={openSnackbar}
        snackbarTitle={snackbarTitle}
        snackbarType={snackbarType}
        close={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={5000}
      />
    </Page>
  );
};

export default QuestionCreate;
